module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700.woff?1f85e92d8ff443980bc0f83ad7b23b60";